import { RootState } from "../types/RootState";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { repositories } from "@service/api/Repositories";
import { SettingsState } from "@service/store/types/SettingsState";
import { SettingRepository } from "@api/repositories/SettingRepository";
import {settingsActionsLists} from "@service/store/settings/actions-list";
import { ActionTree } from "@service/store/types/Store";
import { settingsMutations } from "@service/store/settings/mutations-list";

export const actions: ActionTree<SettingsState, RootState, typeof settingsActionsLists> = {
    async loadLanguages({state, commit, rootGetters}) {
        //languages must changed from eventViewParams if for example event was changed
        let languages = rootGetters['events/selectedEventViewParam']('languages', null) as string[] | null;

        const eventHasLanguages = languages && languages.length;

        if (!eventHasLanguages) {
            if (state.languages === null) {

                languages = await repositories.get<SettingRepository>(RepositoryFabric.SETTING).getLanguages();

                if (!Array.isArray(languages)) {
                    throw new Error("expected Array in languages, got " + typeof languages)
                }

                //save languages to store if only languages was loaded from project settings
                commit(settingsMutations.setLanguages, languages, { root: true });
            }
            else {
                languages = state.languages;
            }
        }

        return languages;
    }
};